import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { useDataContext } from "../hub/data-context-provider.js";
/**
 * Simple create-channel modal. Opens via a "+" button in the ChannelList
 * header (or anywhere callers want). Visibility defaults to `public`;
 * direction defaults to `two-way`. Description is optional.
 */
export function CreateChannelDialog({ workspaceId, onClose, onCreated }) {
    const ctx = useDataContext();
    const [name, setName] = useState("");
    const [description, setDescription] = useState("");
    const [visibility, setVisibility] = useState("public");
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState(null);
    const onSubmit = async (e) => {
        e.preventDefault();
        const trimmed = name.trim();
        if (!trimmed || submitting)
            return;
        setSubmitting(true);
        setError(null);
        try {
            const channel = await ctx.hub.createChannel({
                workspace_id: workspaceId,
                name: trimmed,
                description: description.trim() || undefined,
                visibility,
            });
            onCreated(channel);
            onClose();
        }
        catch (e) {
            setError(e instanceof Error ? e.message : String(e));
        }
        finally {
            setSubmitting(false);
        }
    };
    return (_jsx("div", { style: {
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "grid",
            placeItems: "center",
            zIndex: 100,
        }, children: _jsxs("form", { onSubmit: onSubmit, style: {
                background: "var(--bg-secondary)",
                border: "1px solid var(--border)",
                borderRadius: 10,
                padding: 24,
                width: 420,
                display: "flex",
                flexDirection: "column",
                gap: 16,
            }, children: [_jsx("h2", { style: { margin: 0, fontSize: 16, color: "var(--text-primary)" }, children: "New channel" }), _jsxs("label", { style: { display: "flex", flexDirection: "column", gap: 4 }, children: [_jsx("span", { style: { fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase" }, children: "Name" }), _jsx("input", { type: "text", value: name, onChange: (e) => setName(e.target.value), placeholder: "general", autoFocus: true, required: true, pattern: "[a-z0-9-]+", title: "Lowercase letters, numbers, and hyphens only", style: inputStyle })] }), _jsxs("label", { style: { display: "flex", flexDirection: "column", gap: 4 }, children: [_jsx("span", { style: { fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase" }, children: "Description (optional)" }), _jsx("input", { type: "text", value: description, onChange: (e) => setDescription(e.target.value), placeholder: "What this channel is for...", style: inputStyle })] }), _jsxs("label", { style: { display: "flex", flexDirection: "column", gap: 4 }, children: [_jsx("span", { style: { fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase" }, children: "Visibility" }), _jsxs("select", { value: visibility, onChange: (e) => setVisibility(e.target.value), style: inputStyle, children: [_jsx("option", { value: "public", children: "Public \u2014 all agents see it" }), _jsx("option", { value: "bullpen", children: "Bullpen \u2014 humans only" })] })] }), error && (_jsx("div", { style: {
                        color: "var(--error)",
                        fontSize: 12,
                        padding: 8,
                        border: "1px solid rgba(250,82,82,0.3)",
                        borderRadius: 6,
                    }, children: error })), _jsxs("div", { style: { display: "flex", justifyContent: "flex-end", gap: 8 }, children: [_jsx("button", { type: "button", onClick: onClose, style: { ...btnStyle, background: "transparent", color: "var(--text-secondary)" }, children: "Cancel" }), _jsx("button", { type: "submit", disabled: submitting || !name.trim(), style: {
                                ...btnStyle,
                                background: submitting || !name.trim() ? "var(--bg-hover)" : "var(--accent)",
                                color: "white",
                                cursor: submitting || !name.trim() ? "not-allowed" : "pointer",
                            }, children: submitting ? "Creating…" : "Create" })] })] }) }));
}
const inputStyle = {
    padding: "8px 12px",
    background: "var(--bg-tertiary)",
    border: "1px solid var(--border)",
    borderRadius: 6,
    color: "var(--text-primary)",
    fontSize: 14,
    fontFamily: "inherit",
    outline: "none",
};
const btnStyle = {
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 500,
    border: "none",
    borderRadius: 6,
    cursor: "pointer",
    fontFamily: "inherit",
};
//# sourceMappingURL=CreateChannelDialog.js.map